export default __webpack_public_path__ + "static/media/talent_main-section-video-preview-Dev-IT.837600f6.jpeg";